import * as React from "react";

export const MascotSmall3 = (props: any) => (
  <svg
    width={52}
    height={52}
    viewBox="4 4 44 44"
    fill="#E48A99"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#a)">
      <path
        d="M26 48c12.15 0 22-9.85 22-22S38.15 4 26 4 4 13.85 4 26s9.85 22 22 22Z"
        fill="#fff"
      />
      <path
        d="M26 48c12.15 0 22-9.85 22-22S38.15 4 26 4 4 13.85 4 26s9.85 22 22 22Z"
        opacity={0.15}
      />
      <path d="M36.358 35.958c.238.157.41.393.484.664.075.271.048.56-.075.813a1.186 1.186 0 0 1-.598.568c-.262.113-.557.13-.831.048L28.19 36.05a.937.937 0 0 1-.52-.19.907.907 0 0 1-.316-.447.964.964 0 0 1 .358-.69 1.005 1.005 0 0 1 .758-.22v-2.694c-1.498.322-3.048.33-4.55.02v5.677l3.713 1.73c.237.157.41.393.484.665.075.27.049.56-.075.813a1.186 1.186 0 0 1-.599.568c-.262.113-.557.13-.831.047l-7.147-2.003a.937.937 0 0 1-.52-.19.91.91 0 0 1-.315-.447c-.057-.393.398-.924 1.115-.91v-7.8a10.535 10.535 0 0 1-3.83-5.263 10.332 10.332 0 0 1 .03-6.465 10.54 10.54 0 0 1 3.877-5.23A10.876 10.876 0 0 1 26.085 11a10.88 10.88 0 0 1 6.285 1.95 10.547 10.547 0 0 1 3.938 5.185c.726 2.091.763 4.353.105 6.465a10.528 10.528 0 0 1-3.768 5.305v4.32l3.713 1.733ZM33.985 20.22l-.057-.998-5.99-5.893-.917-.043-.956.6-2.17 8.03.439.814.96.478 8.177-2.171.514-.817Z" />
      <path d="M28.376 20.94c1.435 0 2.598-1.142 2.598-2.549s-1.163-2.548-2.598-2.548c-1.436 0-2.599 1.14-2.599 2.548 0 1.408 1.163 2.548 2.599 2.548Z" />
    </g>
    <defs>
      <filter
        id="a"
        x={0}
        y={0}
        width={52}
        height={52}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0.362353 0 0 0 0 0.418353 0 0 0 0 0.54902 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_74_24554"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_74_24554"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
